import React from "react";

function TitleHeader({ title, id }) {
  return (
    <div className="titleHeader" id={id}>
      <h1 className="title_style">{title}</h1>
    </div>
  );
}

export default TitleHeader;
